import { HttpService, LinesProvider, LinesService } from "@sportal/api";

export const makeLinesService = (
  http: HttpService,
  baseUrl: string
): LinesService => new LinesService(new LinesProvider(http, baseUrl));
